// extracted by mini-css-extract-plugin
export default {"container":"vertical-header_container__iYTSt","verticalImg":"vertical-header_verticalImg__fpN83"};